const table = {
    table: 'text-left w-full border-collapse',
    th_text: 'text-sm text-gray-500 uppercase font-normal',
    td_text: 'text-gray-800',
    tr: 'hover:bg-gray-100'
}

table.th = `${table.th_text} py-1 px-2 lg:py-2 lg:px-4 border-b border-gray-200 text-left`;
table.th_first = `${table.th} !pl-0`;
table.th_last = `${table.th} !pr-0 !text-right`;
table.td = `${table.td_text} py-2 px-2 lg:py-4 lg:px-4 border-b border-gray-200 cursor-pointer`;
table.td_first = `${table.td} !pl-0`;
table.td_last = `${table.td} !pr-0`;

export default table;